import { BrowserRouter, Routes, Route } from "react-router-dom";
import Homepage from "scenes/homePage";
import { useMemo } from "react";
import { CssBaseline, ThemeProvider, createTheme } from "@mui/material";
import { themeSettings } from "./theme";
import RunPage from "scenes/runPage";
import OfferPage from "scenes/offerPage";
import LoginPage from "scenes/loginPage";
import { useSelector } from "react-redux";

function App() {
  const theme = useMemo(() => createTheme(themeSettings()), []);
  const isAuth = Boolean(useSelector((state) => state.token));

  return (
    <div className="app">
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Routes>
            <Route path="/" element={isAuth ? <Homepage /> : <LoginPage />} />
            <Route path="/run" element={isAuth ? <RunPage /> : <LoginPage />} />
            <Route
              path="/run/:id"
              element={isAuth ? <OfferPage /> : <LoginPage />}
            />
            <Route path="*" element={isAuth ? <Homepage /> : <LoginPage />} />
          </Routes>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
